import { storeMixin, storeGenerator, parseApiUrl, parseFilters, parseOrderBy, handleError } from '@/storeMixin'
import { merge } from 'lodash'
import { axiosThux } from '@/axiosThux'

const myinternaltasks = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/task/{profile}/visible-task',
    app: 'dashboard',
    summaryFilter: '',
    maxTreeDepth: 0,
    onlyMine: false
  },
  getters: {
    summaryFilter (state) {
      return state.summaryFilter
    },
    maxTreeDepth (state) {
      return state.maxTreeDepth
    },
    onlyMine (state) {
      return state.onlyMine
    }
  },
  mutations: {
    setSummaryFilter (state, value) {
      state.summaryFilter = value || ''
    },
    setMaxTreeDepth (state, value) {
      state.maxTreeDepth = value || 0
    },
    setOnlyMine (state, value) {
      state.onlyMine = !!value
    }
  },
  actions: {
    setSummaryFilter ({ commit, dispatch }, value) {
      commit('setSummaryFilter', value || '')
      return dispatch('getList')
    },
    setOnlyMine ({ commit, dispatch }, value) {
      commit('setOnlyMine', !!value)
      return dispatch('fetchMaxTreeDepth').then(() => dispatch('getList'))
    },
    async fetchMaxTreeDepth ({ state, commit, dispatch }) {
      let url = `${parseApiUrl(this, state.apiUrl)}/my-internal-tree-depth/`
      if (state.onlyMine) {
        url = `${url}?only_mine=true`
      }
      return axiosThux.get(url)
        .then((resp) => {
          commit('setMaxTreeDepth', (resp.data && resp.data.max_tree_depth) || 0)
        })
        .catch((error) => {
          handleError(commit, dispatch, error)
        })
    },
    async getList ({ state, commit, getters, dispatch }) {
      let url = `${parseApiUrl(this, state.apiUrl)}/my-internal/?`
      url = `${url}${getters.perPage ? 'per_page=' + getters.perPage : ''}`
      url = `${url}${getters.page ? '&page=' + getters.page : ''}`
      url = `${url}${getters.orderBy ? '&order_by__=' + getters.orderBy : ''}`
      if (state.onlyMine) {
        // Radici effettive: figli assegnati con padre non assegnato promossi a root.
        url = `${url}&my_roots=true&only_mine=true`
      } else {
        url = `${url}&parent__isnull=true`
      }
      if (state.summaryFilter) {
        url = `${url}&summary_filter=${state.summaryFilter}`
      }
      url = parseOrderBy(getters, url)
      url = parseFilters(getters, url)
      return axiosThux.get(url)
        .then(response => {
          commit('setList', response.data)
          commit('setPerPage', response.data.per_page)
        }).catch(error => {
          handleError(commit, dispatch, error)
        })
    }
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'dashboard', model: 'myinternaltasks' }
    ),
    {
      GENERIC: {
        dashboard: {
          myinternaltasks: {
            LIST: {
              ACTIONS: {
                setSummaryFilter: 'GENERIC/dashboard/myinternaltasks/setSummaryFilter',
                fetchMaxTreeDepth: 'GENERIC/dashboard/myinternaltasks/fetchMaxTreeDepth',
                setOnlyMine: 'GENERIC/dashboard/myinternaltasks/setOnlyMine'
              },
              MUTATIONS: {
                setSummaryFilter: 'GENERIC/dashboard/myinternaltasks/setSummaryFilter'
              },
              GETTERS: {
                summaryFilter: 'GENERIC/dashboard/myinternaltasks/summaryFilter',
                maxTreeDepth: 'GENERIC/dashboard/myinternaltasks/maxTreeDepth'
              }
            }
          }
        }
      }
    }
  )
)()

export { myinternaltasks, TYPES }
